/*
 * @Description: 
 * @Author: zcy
 * @Date: 2022-01-10 15:20:58
 * @LastEditors: zcy
 * @LastEditTime: 2022-02-23 16:10:13
 */
import http from "@/axios/index";
/**接口根路经标识 */

export function initPageList(data) {
  const url = `/outSaleCostGroup/searchOutSaleCostGroupList`
  return http.post(url, data)
}

// 获取所有区域--育苗成本概览
export function getAllJiGou(data){
  const url = `/outSaleCostGroup/getGroupConditions`
  return http.post(url,data)
}

// 获取所有批次--育苗成本概览
export function getAllPiCi(data){
  const url = `/outSaleCostGroup/getSeedlingConditions`
  return http.post(url,data)
}
// 获取所有品类--育苗成本概览
export function getAllPinLei(data){
  const url = `/outSaleCostGroup/getTypeConditions`
  return http.post(url,data)
}
// 获取所有品种--育苗成本概览
export function getAllPinZhong(data){
  const url = `/outSaleCostGroup/getBreedConditions`
  return http.post(url,data)
}

